import { createSlice } from '@reduxjs/toolkit';
import { getAdminType } from '../../utils/adminType';
import { getAdminEmail } from '../../utils/adminEmail';

const initialState = {
    isLoggedIn: (sessionStorage.getItem('cc-t') || localStorage.getItem('cc-t')) ? true : false,
    adminType: getAdminType(),
    token: (sessionStorage.getItem('cc-t') || localStorage.getItem('cc-t')) || null,
    viewAllTabs: (sessionStorage.getItem('view') === 'true' || localStorage.getItem('view') === 'true') ? true : false,
    email: getAdminEmail(),
}

export const counterSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        LOGIN: (state, action) => {
            state.isLoggedIn = true;
            state.adminType = action.payload.adminType;
            state.token = action.payload.accessToken;
            state.viewAllTabs = action.payload.viewAllTabs;
            state.email = action.payload.email;
        },
        LOGOUT: (state) => {
            state.isLoggedIn = false;
            state.adminType = null;
            state.token = null;
            state.viewAllTabs = false;
            state.email = null;
        },
        RESET_PASSWORD_INITIATE: (state, action) => {
            state.isLoggedIn = false;
            state.adminType = null;
            state.token = null;
            state.viewAllTabs = false;
            state.email = null;
        },
        RESET_PASSWORD_OTP_UPDATE: (state, action) => {
            state.isLoggedIn = false;
            state.adminType = null;
            state.token = null;
            state.viewAllTabs = false;
            state.email = null;
        },
        RESET_PASSWORD_SUCCESS: (state) => {
            state.isLoggedIn = false;
            state.adminType = null;
            state.token = null;
            state.viewAllTabs = false;
            state.email = null;
        },
    },
})

// Action creators are generated for each case reducer function
export const { LOGIN, LOGOUT } = counterSlice.actions

export default counterSlice.reducer